import { render, staticRenderFns } from "./r-prompt-page.vue?vue&type=template&id=49e5902d"
import script from "./r-prompt-page.vue?vue&type=script&lang=js"
export * from "./r-prompt-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49e5902d')) {
      api.createRecord('49e5902d', component.options)
    } else {
      api.reload('49e5902d', component.options)
    }
    module.hot.accept("./r-prompt-page.vue?vue&type=template&id=49e5902d", function () {
      api.rerender('49e5902d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/prompt/r-prompt-page.vue"
export default component.exports